if (!customElements.get("filter-facets")) {
  let appendHTML = false;
  class FilterFacets extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.filters = this.form.querySelectorAll("details:not(.sort-group)");
      this.isFetching = false;
      FilterFacets.productListWrapper =
        document.getElementById("collection-products-list") ||
        document.getElementById("search-products-list");
      try {
        FilterFacets.filterHeadlinePrefixes = JSON.parse(
          document.querySelector('script[data-json="filter-headline-prefix"]')
            .textContent ?? [],
        );
      } catch (e) {
        FilterFacets.filterHeadlinePrefixes = [];
      }
    }

    connectedCallback() {
      this.popstateHandler = this.popstateHandler.bind(this);
      this.documentClickHandler = this.documentClickHandler.bind(this);
      this.priceFilterMinValue = this.getAttribute(
        "data-price-filter-min-value",
      );
      this.priceFilterMaxValue = this.getAttribute(
        "data-price-filter-max-value",
      );

      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener("popstate", this.popstateHandler);
      document.removeEventListener("click", this.documentClickHandler);
    }

    init() {
      if (this.form.id == "filterForm") {
        if (FilterFacets.filterData.length == 0) {
          const sectionID = this.form
            .closest(".shopify-section")
            .id.replace("shopify-section-", "");
          FilterFacets.renderSectionFromFetch(
            new URL(window.location.href).searchParams.toString(),
            sectionID,
            "list",
            false,
          );
        }

        this.initListenersDesktop();
        if (this.querySelector("sort-by-select")) {
          this.querySelector("sort-by-select").remove();
        }
        FilterFacets.initWishlistButtons();
      }

      [
        ...this.form.querySelectorAll(".filter-group-display__clear"),
        ...document.querySelectorAll(".filter-tag--close"),
        ...document.querySelectorAll('[class$="--pagination"] a'),
        ...document.querySelectorAll(".filter-tag--remove-all a"),
      ].forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();

          if (this.isFetching) return;

          if (e.currentTarget.classList.contains("filter-tag--close")) {
            e.currentTarget.closest("li").remove();
          }
          const url = new URL(el.href);

          let searchParams = this.checkSearchParams(url.searchParams);
          const queryString = searchParams.toString();
          this.submit(queryString);

          if (e.currentTarget.closest('[class$="--pagination"]')) {
            window.scroll({
              top: window.matchMedia("screen and (min-width: 1024px)").matches
                ? document
                    .querySelector('[class$="--content__header-toolbar"]')
                    .getBoundingClientRect() +
                  window.scrollY -
                  10
                : document
                    .querySelector('[class$="--content__header-toolbar"]')
                    .getBoundingClientRect() +
                  window.scrollY -
                  75,
              behavior: "smooth",
            });
          }
        });
      });

      this.form.addEventListener("submit", async (e) => {
        const activeFilters = [...new FormData(this.form).entries()].filter(
          ([key]) => key.startsWith("filter."),
        );
        if (activeFilters.length > 0) {
          const collection = document.querySelector(".collection");
          window.dataLayer = window.dataLayer || [];
          activeFilters.forEach(([key, value]) => {
            window.dataLayer.push({
              event: "filter_applied",
              filter_category: key,
              filter_value: value,
              collection:
                (collection && collection.dataset.collectionTitle) || undefined,
            });
          });
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (this.isFetching) return;
        await theme.yieldToMain();
        document.getElementById("filters").removeAttribute("open");
        document.body.classList.remove("flyout-open");
        document.body.classList.remove("no-scroll");
        document.documentElement.classList.remove("no-scroll");
        await theme.yieldToMain();
        this.submit();
      });
    }

    submit(queryString, pushHistory = true) {
      this.closeAllFilters();
      this.isFetching = true;
      let searchParams = new URLSearchParams(new FormData(this.form));

      const searchParamsMinPrice = searchParams.get("filter.v.price.gte");
      const searchParamsMaxPrice = searchParams.get("filter.v.price.lte");
      if (searchParamsMinPrice !== null) {
        if (searchParamsMinPrice === this.priceFilterMinValue) {
          searchParams.delete("filter.v.price.gte");
        }
      }
      if (searchParamsMaxPrice !== null) {
        if (searchParamsMaxPrice === this.priceFilterMaxValue) {
          searchParams.delete("filter.v.price.lte");
        }
      }
      searchParams = this.checkSearchParams(searchParams);
      queryString =
        queryString || queryString == ""
          ? queryString
          : searchParams.toString();
      const sectionID = this.form
        .closest(".shopify-section")
        .id.replace("shopify-section-", "");
      const view = document.querySelector('.view-switch [aria-selected="true"]')
        .dataset.view;

      if (!this.form.closest(".shopify-section")) return;

      const filterDataUrl = (element) =>
        element.queryString === queryString ||
        element.queryString === queryString.replace("&page=1", "");

      if (!appendHTML) {
        FilterFacets.filterData.some(filterDataUrl)
          ? FilterFacets.renderSectionFromCache(queryString, sectionID, view)
          : FilterFacets.renderSectionFromFetch(queryString, sectionID, view);
      } else {
        FilterFacets.renderSectionFromFetch(queryString, sectionID, view);
      }

      if (pushHistory) {
        FilterFacets.updateURLHash(queryString);
      }
    }

    checkSearchParams(searchParams) {
      const params = [...searchParams.keys()].filter(key => key.includes('filter.v.') && !key.includes('filter.v.price') && !key.includes('filter.v.availability'));
      if(params.length > 0 && !searchParams.has('filter.v.availability')) {
        searchParams.append('filter.v.availability', 1);
      } else if(params.length === 0 && !window.location.href.includes('/search')) {
        searchParams.delete('filter.v.availability');
      }
      
      if (searchParams.get("sort_by") == "") {
        searchParams.delete("sort_by");
      }

      return searchParams;
    }

    static renderSectionFromFetch(
      queryString,
      sectionID,
      view,
      renderToDOM = true,
    ) {
      if (renderToDOM && !appendHTML) {
        FilterFacets.renderSkeletons();
      }

      FilterFacets.handleCanonicalUrl(queryString);

      fetch(
        `${window.location.pathname}?section_id=${sectionID}&${queryString}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          let html = parser.parseFromString(responseText, "text/html");
          FilterFacets.filterData = [
            ...FilterFacets.filterData,
            { html, queryString },
          ];
          html = FilterFacets.setView(html, view);
          if (!renderToDOM) return;
          FilterFacets.renderNewHtml(html, sectionID);
        })
        .catch((error) => {
          if (!renderToDOM) return;
          let errorMessage = document.querySelector(
            "filter-facets[data-error-message]",
          ).dataset.errorMessage;
          FilterFacets.renderError(errorMessage ? errorMessage : "");
        });
    }

    static renderSectionFromCache(queryString, sectionID, view) {
      const filterDataUrl = (element) =>
        element.queryString === queryString ||
        element.queryString === queryString.replace("&page=1", "");
      let html = FilterFacets.filterData.find(filterDataUrl).html;
      html = FilterFacets.setView(html, view);
      FilterFacets.handleCanonicalUrl(queryString);
      FilterFacets.renderNewHtml(html, sectionID);
    }

    static handleCanonicalUrl(queryString) {
      const canonicalUrl = document.querySelector("link[rel='canonical']");
      if (!canonicalUrl) return;

      const searchParams = new URLSearchParams(queryString);
      const staticAllowedFilters = [
        "page",
        ...(!/\/search/.test(canonicalUrl.href)
          ? ["filter.v.availability"]
          : ["type"]),
      ];
      let allowedFilters = FilterFacets.filterHeadlinePrefixes;
      staticAllowedFilters.forEach((key) => {
        allowedFilters.push({ key, value: null });
      });

      let activeIndexableFilters = [];
      if (FilterFacets.filterHeadlinePrefixes.length > 0) {
        [...searchParams.keys()].forEach((key) => {
          const matchingFilters = allowedFilters.filter((filter) => {
            if (!staticAllowedFilters.includes(key)) {
              return (
                filter.key === key && filter.value === searchParams.get(key)
              );
            } else {
              return true;
            }
          });
          if (matchingFilters.length === 0) {
            searchParams.delete(key);
          } else {
            if (!staticAllowedFilters.includes(key)) {
              activeIndexableFilters.push(key);
            }
          }
        });
      }

      // page=1 is same as no page parameter
      if (searchParams.get("page") == 1) {
        searchParams.delete("page");
      }

      // remove search specific parameters on empty or no search-query parameter
      if (
        /\/search/.test(canonicalUrl.href) &&
        (searchParams.get("q") === "" || searchParams.get("q") === null)
      ) {
        searchParams.delete("q");
        searchParams.delete("type");
        searchParams.delete("page");
      }

      // remove filter.v.availability if no indexable filter is active
      if (activeIndexableFilters.length === 0) {
        searchParams.delete("filter.v.availability");
      }

      FilterFacets.handleDescriptionVisibility(
        queryString,
        activeIndexableFilters.length > 0,
      );

      // set new canonical url
      canonicalUrl.href = `${canonicalUrl.href.split("?")[0]}${
        searchParams.toString() == "" ? "" : "?"
      }${searchParams.toString()}`;
    }

    static handleDescriptionVisibility(queryString, hasIndexableFilters) {
      const searchParams = new URLSearchParams(queryString);
      const isNotFirstPage = Boolean(
        searchParams.get("page") && searchParams.get("page") !== 1,
      );

      if (hasIndexableFilters || isNotFirstPage) {
        document
          .querySelector(".silo__description")
          ?.setAttribute("hidden", true);
        document
          .querySelector(".silo__description")
          ?.setAttribute("aria-hidden", true);
        document
          .querySelector(".collection--content__description")
          ?.setAttribute("hidden", true);
        document
          .querySelector(".collection--content__description")
          ?.setAttribute("aria-hidden", true);
        document
          .querySelector("[id*=__shogun-above] > div")
          ?.setAttribute("hidden", true);
        document
          .querySelector("[id*=__shogun-above] > div")
          ?.setAttribute("aria-hidden", true);
        document
          .querySelector("[id*=__shogun-below] > div")
          ?.setAttribute("hidden", true);
        document
          .querySelector("[id*=__shogun-below] > div")
          ?.setAttribute("aria-hidden", true);
      } else {
        document.querySelector(".silo__description")?.removeAttribute("hidden");
        document
          .querySelector(".silo__description")
          ?.removeAttribute("aria-hidden");
        document
          .querySelector(".collection--content__description")
          ?.removeAttribute("hidden");
        document
          .querySelector(".collection--content__description")
          ?.removeAttribute("aria-hidden");
        document
          .querySelector("[id*=__shogun-above] > div")
          ?.removeAttribute("hidden");
        document
          .querySelector("[id*=__shogun-above] > div")
          ?.removeAttribute("aria-hidden");
        document
          .querySelector("[id*=__shogun-below] > div")
          ?.removeAttribute("hidden");
        document
          .querySelector("[id*=__shogun-below] > div")
          ?.removeAttribute("aria-hidden");
      }
    }

    initListenersDesktop() {
      this.filters.forEach((element) => {
        element.addEventListener("pointerup", () => {
          this.filters.forEach((el) => {
            if (!element.isEqualNode(el)) {
              el.removeAttribute("open");
            }
          });
        });
      });

      [...this.form.querySelectorAll('input[type="submit')].forEach(
        (element) => {
          element.addEventListener("click", () => {
            this.closeAllFilters();
          });
        },
      );

      window.addEventListener("popstate", this.popstateHandler);
      document.addEventListener("click", this.documentClickHandler);
    }

    closeAllFilters() {
      this.filters.forEach((el) => {
        el.removeAttribute("open");
      });
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${
          searchParams && "?".concat(searchParams)
        }`,
      );
    }

    static async renderSkeletons() {
      if (!appendHTML) FilterFacets.productListWrapper.innerHTML = ``;
      let html = "";
      await theme.yieldToMain();
      for (let i = 0; i < 24; i++) {
        html += `<div class="skeleton">
        <div class="skeleton-box"></div>
        <div class="skeleton-box"></div>
      </div>`;
      }
      FilterFacets.productListWrapper.innerHTML = html;
    }

    static renderError(errorMessage) {
      FilterFacets.productListWrapper.innerHTML = ``;
      FilterFacets.productListWrapper.insertAdjacentHTML(
        "beforeend",
        `
        <div class="collection--content__no-matches">${errorMessage}</div>
      `,
      );
    }

    static setView(html, view) {
      [...html.querySelectorAll(`.view-switch [data-view]`)].forEach((el) => {
        el.setAttribute("aria-current", false);
        el.setAttribute("aria-selected", false);
      });

      if (
        html.querySelector(`.view-switch [data-view="${view}"]`) &&
        html.querySelector(`[id$="-products-list"]`)
      ) {
        html
          .querySelector(`.view-switch [data-view="${view}"]`)
          .setAttribute("aria-current", true);
        html
          .querySelector(`.view-switch [data-view="${view}"]`)
          .setAttribute("aria-selected", true);
        html.querySelector(`[id$="-products-list"]`).dataset.view = view;
      }

      return html;
    }

    static async renderNewHtml(html, sectionID) {
      this.isFetching = false;
      const section = document.getElementById(`shopify-section-${sectionID}`);
      await theme.yieldToMain();
      if (
        html.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li:nth-child(2)',
        )
      ) {
        section.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li:nth-child(2)',
        ).innerHTML = html.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li:nth-child(2)',
        ).innerHTML;
      }
      await theme.yieldToMain();
      if (
        html.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li > .mobile--hidden',
        )
      ) {
        section.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li > .mobile--hidden',
        ).innerHTML = html.querySelector(
          '[class$="--content__header"] [class$="--content__header-toolbar"] li > .mobile--hidden',
        ).innerHTML;
      }
      await theme.yieldToMain();
      if (html.querySelector('[class$="--content__product-list"]')) {
        if (!appendHTML) {
          section.querySelector(
            '[class$="--content__product-list"]',
          ).innerHTML = html.querySelector(
            '[class$="--content__product-list"]',
          ).innerHTML;
        } else {
          [
            ...section.querySelectorAll(
              '[class$="--content__product-list"] [id$="-products-list"] .skeleton',
            ),
          ].forEach((skeleton) => skeleton.remove());
          section
            .querySelector(
              '[class$="--content__product-list"] [id$="-products-list"]',
            )
            .insertAdjacentHTML(
              "beforeend",
              html.querySelector(
                '[class$="--content__product-list"] [id$="-products-list"]',
              ).innerHTML,
            );
          section.querySelector(
            '[class$="--content__product-list"] footer',
          ).innerHTML = html.querySelector(
            '[class$="--content__product-list"] footer',
          ).innerHTML;
          appendHTML = false;
        }
      }
      await theme.yieldToMain();
      if (html.querySelector('#filters [class$="--filter"]')) {
        section.querySelector('#filters [class$="--filter"]').innerHTML =
          html.querySelector('#filters [class$="--filter"]').innerHTML;
      }
      await theme.yieldToMain();
      theme.initMaskedLinks(section);
      if (FilterFacets.filterHeadlinePrefixes.length > 0) {
        const searchParams = new URLSearchParams(window.location.search);
        const currentFilter = FilterFacets.filterHeadlinePrefixes.find(
          (filter) => searchParams.get(filter.key) == filter.value,
        );
        const collectionTitle =
          document.querySelector("section.collection")?.dataset
            ?.collectionTitle;
        if (collectionTitle) {
          if (
            currentFilter &&
            searchParams.getAll(currentFilter.key).length == 1 &&
            searchParams.getAll(currentFilter.key)[0] === currentFilter.value
          ) {
            document.querySelector(
              ".collection--header h1",
            ).innerText = `${currentFilter.label} ${collectionTitle}`;
            document.querySelector(
              ".breadcrumb--item-current",
            ).innerText = `${currentFilter.label} ${collectionTitle}`;
          } else {
            document.querySelector(".collection--header h1").innerText =
              collectionTitle;
            document.querySelector(".breadcrumb--item-current").innerText =
              collectionTitle;
          }
        }
      }
    }

    popstateHandler() {
      const url = new URL(window.location.href);
      const queryString = url.searchParams.toString();
      this.submit(queryString, false);
    }

    documentClickHandler(e) {
      if (e.target.closest(".filter-group") != null) return;
      if (e.target.id == "load-more") {
        e.preventDefault();

        if (this.isFetching) return;

        e.target.classList.add("btn--loading");

        const url = new URL(e.target.href);

        let searchParams = this.checkSearchParams(url.searchParams);
        const queryString = searchParams.toString();

        appendHTML = true;
        this.submit(queryString, false);
      }
      this.closeAllFilters();
    }

    static initWishlistButtons() {
      setTimeout(() => {
        const cards = document.querySelectorAll('[class$="--products"] .card');

        document
          .querySelector("body")
          .classList.remove("swym-ready", "swym-buttons-loaded");
        for (let i = 1; i <= cards.length; i++) {
          if (window._swat) {
            window._swat.initializeActionButtons(
              `[class$="--products"] .card:nth-child(${i})`,
            );
          }
          document
            .querySelector(
              `[class$="--products"] .card:nth-child(${i}) .card--wishlist-toggle`,
            )
            .addEventListener("click", (e) => {
              setTimeout(() => {
                e.target.classList.remove("swym-removing");
                e.target.classList.remove("swym-added");
              }, 0);
            });
        }
      }, 0);
    }
  }
  if (!FilterFacets.filterData) {
    FilterFacets.filterData = [];
  }
  customElements.define("filter-facets", FilterFacets);
}
